/* Pawsly - swap collection card images to the chosen colour */
(function () {
  if (window.__pawslyColourSwitch) return;
  window.__pawslyColourSwitch = true;

  var map = {};
  try {
    var el = document.getElementById('pw-cmap');
    if (el) map = JSON.parse(el.textContent) || {};
  } catch (e) {}

  var usable = Object.keys(map).some(function (k) {
    return map[k] && Object.keys(map[k]).length > 1;
  });
  if (!usable) {
    document.querySelectorAll('.pw-cs').forEach(function (s) { s.style.display = 'none'; });
    return;
  }

  var current = '';
  var busy = false;
  var timer;

  function cards() {
    var out = [];
    document.querySelectorAll('img.product-media__image').forEach(function (img) {
      var a = img.closest('a[href*="/products/"]');
      if (!a) return;
      var h = a.getAttribute('href').split('/products/')[1];
      if (!h) return;
      h = h.split('?')[0].split('#')[0].split('/')[0];
      out.push({ img: img, handle: h });
    });
    return out;
  }

  function apply() {
    if (busy) return;
    busy = true;
    try {
      cards().forEach(function (c) {
        var img = c.img;
        if (!img.dataset.pwOrig) {
          img.dataset.pwOrig = img.getAttribute('src') || '';
          img.dataset.pwOrigSet = img.getAttribute('srcset') || '';
        }
        var m = map[c.handle];
        if (current && m && m[current]) {
          if (img.getAttribute('src') !== m[current]) {
            img.setAttribute('srcset', '');
            img.setAttribute('sizes', '');
            img.setAttribute('src', m[current]);
          }
        } else if (img.dataset.pwOrig && img.getAttribute('src') !== img.dataset.pwOrig) {
          img.setAttribute('srcset', img.dataset.pwOrigSet || '');
          img.setAttribute('src', img.dataset.pwOrig);
        }
      });
    } catch (e) {}
    busy = false;
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.pw-cs__btn') : null;
    if (!b) return;
    e.preventDefault();
    current = b.getAttribute('data-pwc') || '';
    document.querySelectorAll('.pw-cs__btn').forEach(function (x) {
      x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
    });
    apply();
  }, true);

  try {
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 150);
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}

  if (document.readyState !== 'loading') apply();
  else document.addEventListener('DOMContentLoaded', apply);
})();
